import React from 'react';
import style from 'styled-components';

import {
  Box,
  Grommet,
  Anchor,
} from 'grommet';

import Logo from '../App/tradertax.png';
import Signup from '../App/Signup';

const fontSizing = (factor) => {
  const baseSpacing = 24;
  const scale = 6;

  // 24
  const baseFontSize = baseSpacing * 0.75; // 18
  const fontScale = baseSpacing / scale; // 4

  return {
    family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans",  "Helvetica Neue", Arial, sans-serif,  "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    size: `${baseFontSize + factor * fontScale}px`,
    height: `${baseSpacing + factor * fontScale}px`,
    // maxWidth chosen to be ~50 characters wide
    // see: https://ux.stackexchange.com/a/34125
    maxWidth: `${baseSpacing * (baseFontSize + factor * fontScale)}px`,
  };
};

const theme = {
  global: {
    colors: {
      brand: '#2979ff',
    },

    font: fontSizing(-1),
  },

  paragraph: {
    small: { ...fontSizing(-1) },
    medium: { ...fontSizing(-1) },
    large: { ...fontSizing(-1) },
    xlarge: { ...fontSizing(-1) },
    xxlarge: { ...fontSizing(-1) },
  },

  text: {
    small: { ...fontSizing(-1) },
    medium: { ...fontSizing(-1) },
    large: { ...fontSizing(-1) },
    xlarge: { ...fontSizing(-1) },
    xxlarge: { ...fontSizing(-1) },
  },

  button: {
    border: {
      radius: '4px',
    },
  },
};

const LogoImage = style('img')`
  max-width: 250px;
  margin-top: 50px;
  margin-bottom: 30px;
`;

const App = () => (
  <Grommet theme={theme} full>
    <Box
      background="brand"
      fill
      align="center"
      direction="column"
    >
      <LogoImage src={Logo} alt="TRADERTAX Logo" />

      <Box
        background="white"
        elevation="medium"
        width="500px"
        flex={false}
        margin="small"
        pad={{
          vertical: 'medium',
          horizontal: 'medium',
        }}
        round="small"
        align="center"
      >
        <Signup />
      </Box>

      <Anchor alignSelf="center" href="/" color="white">Voltar à página inicial</Anchor>
    </Box>
  </Grommet>
);

export default App;
